import { useSnapshot } from "valtio";
import { reportAccessStore } from "../stores/reportAccessStore";
import { rootStore } from "../store";

interface UseViewReportHandlerParams {
  id?: string;
  symbol?: string;
  type: "crypto" | "stock";
}

export const useViewReportHandler = ({
  id,
  symbol,
  type,
}: UseViewReportHandlerParams) => {
  const { isLoggedIn } = useSnapshot(rootStore.login);

  const handleViewReport = async (e: React.MouseEvent<HTMLButtonElement>) => {
    // 总是阻止事件冒泡，避免触发表格行的点击事件
    e.stopPropagation();
    reportAccessStore.requestReportAccess(
      { type, symbol, id },
      isLoggedIn ?? false,
    );
  };

  return {
    handleViewReport,
  };
};
